module.exports = __webpack_public_path__ + "img/scroll-top-hover.a4ec6378.png";